<script>
import appConfig from "@/app.config";
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
    }
  },
  methods: {
    getImgUrl(img) {
      if (img) {
        //return require("@/assets/images/icons/" + img);
        return this.assetsPath + 'images/gif/' + img;
      }
      return "";
    },
  },
};
</script>

<template>
  <div :class="[$style.colorCard, data.bgColor]" class="d-flex flex-column w-100 rounded-14 card-shadow justify-content-center align-items-center  text-center">
    <div :class="$style.icon">
        <img
          :src="getImgUrl(data.logo)"
          alt=""
          :class="$style.logoImg"
        />
    </div>
    <h2 :class="$style.heading">{{data.name}}</h2>
    <p>{{data.info}}</p>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.colorCard {
    overflow: hidden;
    padding: 30px 33px;
    height: calc(100%);
    .icon{
        text-align: center;
        margin-bottom: 20px;
    }
    .heading{
        margin-bottom: 15px;
        font-size: 20px;
        color: $white;
    }
    p{
        font-size: 17px;
        color: $white;
    }
    .logoImg{
      max-width: 129px;
      max-height: 129px;
    }
 
}
</style>
